import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import URLS from "@api/constants/urls";

export const useGetAllCityService = ({
  page = "1",
  per_page = "15",
  enableQuery,
  showActiveOnly = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const stateId = urlQueries?.["state-id"] || "";
  const created_between = urlQueries["created_between"] || "";
  const allCityService = useQuery({
    queryKey: [
      ...CACHE_KEYS.CITY,
      page,
      per_page,
      showActiveOnly,
      debouncedQuery,
      created_between,
    ],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.CITIES,
        searchParams: {
          page,
          per_page,
          include: "state",
          "filter[name]": debouncedQuery,
          "filter[state_id]": stateId,
          "filter[created_between]": created_between,
        },
      }),
    enabled: enableQuery,
  });

  return {
    states: { searchQuery, setSearchQuery },
    services: { allCityService },
  };
};
